import * as React from 'react';
import Context from '../State/Context';
import { Input } from './MlrForm';
import { Select, TextToSelectOption } from './Select';
import Total from './Total';

interface IControlStock {
    value: number
    name: string
    total?: string
    isParentEnabled: boolean
    onChangeName: (value: string) => void
    onChangeValue: (value: number) => void
    rowNumber: number
}

export const ControlStock = ({ value, name, total, onChangeName, onChangeValue, isParentEnabled, rowNumber }: IControlStock) => (
    <Context.Consumer>
        {({ stock }) => {
            const stockOptions = stock.map(item => item.name);
            const onChangeText = (e: React.FormEvent<HTMLSelectElement>) => onChangeName(e.currentTarget.value);
            const onChangeNumber = (e: React.FormEvent<HTMLInputElement>) => onChangeValue(Number(e.currentTarget.value));

            const msRowStyle = { msGridRow: rowNumber };

            return (
                <React.Fragment>
                    <Select
                        disabled={!isParentEnabled}
                        options={stockOptions.map(TextToSelectOption)}
                        selectedValue={name}
                        onChange={onChangeText}
                        style={msRowStyle}
                    />
                    <Input type="number" value={value} onChange={onChangeNumber} disabled={!isParentEnabled} style={msRowStyle}/>
                    {total && <Total enabled={isParentEnabled} rowNumber={rowNumber}>{total}</Total>}
                </React.Fragment>
            )
        }}
    </Context.Consumer>
);


// WEBPACK FOOTER //
// ./src/Components/ControlStock.tsx